export default __webpack_public_path__ + "static/background-c5beefa4c3024708d55445c6d621a778.png";